import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Loading from '../../../components/loading';
import SectionHeader from '../../../components/sectionHeader';

import PERMITMODULE from '../../../icons/PERMITMODULE.png';
import searchIcon from '../../../icons/search.svg';
import styles from '../../forms/List/form_list.module.scss';
import formStyles from '../../forms/completeForm/form_complete.module.scss';
import Button from '../../../components/button';
import { clearFormActions, fetchFormAnswers, fetchHangarInspectionAnswers, getAllPublishedFormList } from '../redux/actions';
import { INSPECTIONS } from '../../../constants/RouterConstants';
import InspectionTable from './InspectionTable';
import Clickable from '../../../components/clickable/Clickable';
import { importAllImages } from '../../../utils/helpers';
import Tabel from './HangarInspectionTabel';

export default function InspectionList(props) {
  const images = importAllImages(require.context('../../../icons/inspection-icons', false, /\.(png|jpe?g|svg)$/));
  const dispatch = useDispatch();
  const inspectionAnswerLogs = useSelector(state => state.inspection?.formsAnswerList);
  const hangarInspectionAnswerLogs = useSelector(state => state.inspection?.hangarAnswerList);
  const loadingAction = useSelector(state => state.inspection?.formAnswerListAction);
  const formsList = useSelector(state => state.inspection?.publishedFormsList);


  const [loadData, handleLoading] = useState(false);
  const [activeTab, handleActiveTab] = useState('inspections');
  const [usedForms, handleUseForms] = useState([]);
  useEffect(() => {
    handleLoading(true);
    dispatch(fetchFormAnswers());
    dispatch(getAllPublishedFormList());
    dispatch(fetchHangarInspectionAnswers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleUseForms(formsList);
  }, [formsList]);

  useEffect(() => {
    if (loadingAction?.loading === false && loadingAction?.success === true) {
      handleLoading(false);
      dispatch(clearFormActions());
    }
  }, [dispatch, loadingAction]);

  const handleFormTabs = (value) => {
    handleActiveTab(value);
  };

  const goToForm = (form) => {
    dispatch(clearFormActions());
    const { history } = props;
    if (form?.id !== undefined) {
      history.push(`/myinspections/${form.id}/complete`);
    }
  };

  const handleSearchForm = (event) => {
    let searchVal = event.target.value;
    let searchedForms = formsList?.filter(formVal => formVal.title?.toLowerCase().indexOf(searchVal?.toLowerCase()) > -1);
    handleUseForms(searchedForms);
  };

  return (
    <>
      <Loading loadingStatus={loadData} />
      <SectionHeader icon={PERMITMODULE} translationID="my_inspections" defaultTitle="My Inspections" centered {...props}>
        <div className={styles.navigation} style={{ position: 'absolute' }}>
          <Clickable
            className={activeTab === 'inspections' ? styles.active : ''}
            onClick={() => handleFormTabs('inspections')}
          >
            <FormattedMessage id="myform.forms.title" defaultMessage="Inspections" />
          </Clickable>
          <Clickable
            className={activeTab === 'hangar_inspections' ? styles.active : ''}
            onClick={() => handleFormTabs('hangar_inspections')}
          >
            <FormattedMessage id="myform.forms.title" defaultMessage="Hangar Inspections" />
          </Clickable>
          <Clickable
            className={activeTab === 'history' ? styles.active : ''}
            onClick={() => handleFormTabs('history')}
          >
            <span>History</span>
          </Clickable>
        </div>
        <div className={styles.detailHeader} />
      </SectionHeader>
      {activeTab === 'history' && (
        <div style={{ display: 'flex' }} className={styles.toolbar}>
          <div className={styles.counter}>
            <FormattedMessage
              id="adp.list.open"
              defaultMessage={`All Inspections (${inspectionAnswerLogs?.length ? inspectionAnswerLogs?.length : 0})`}
            />
          </div>
        </div>)}
      <div style={{ marginTop: '2vw' }}>
        <div className={styles.tableContainer}>
          {activeTab === 'inspections' && (
            <div style={{ border: '1px solid #E6EAEE' }}>
              <div className={formStyles.searchBarInput}>
                <FormattedMessage id="myform.forms.title"
                  tagName="h3"
                  defaultMessage="Inspections"
                />
                <div className={styles.searchUser}>
                  <img src={searchIcon} alt="" />
                  <input
                    onChange={e => handleSearchForm(e)}
                    placeholder="Search..."
                    id="search"
                    name="formSearch"
                  />
                </div>
              </div>
              <div className={formStyles.inspection_list}>
                <div className={formStyles.inspection_list__item_container}>
                  {usedForms && usedForms?.length > 0
                    ? usedForms.map(form => (
                      <div
                        key={form.form_key}
                        className={formStyles.inspection_list__item}
                      >
                        <div>
                          {images[`${form.icon}.svg`]
                            ? <img src={images[`${form.icon}.svg`]?.default} alt="inspection_icon" />
                            : <img src={images[form.icon]?.default} alt="inspection_icon" />
                          }
                          <span>{form.title}</span>
                        </div>
                        <div className={formStyles.submitButton}>
                          <Button
                            action="primary"
                            onClick={() => goToForm(form)}
                            translationID="myforms_Submit"
                            defaultText="Submit"
                          />
                        </div>
                      </div>
                    )) : (
                    <div style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="forms.list.table.no_results"
                        defaultMessage="No Data Found"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {activeTab === 'history'
            && (
            <InspectionTable
              data={inspectionAnswerLogs}
              url={INSPECTIONS}
            />
            )
          }
          {activeTab === 'hangar_inspections' && (
            <Tabel
              info={hangarInspectionAnswerLogs || []}
            />
          )}
        </div>
      </div>
    </>
  );
}
